import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

import { EvaluationContext } from './models/feature-flag.model';

export type FeatureRule = { value: boolean };
export type FeatureValue = boolean | FeatureRule;

export const FEATURE_TOGGLER = new InjectionToken<FeatureToggler>('FEATURE_TOGGLER');

export type Context = string | Record<string, any>;

/**
 * Represents a feature toggler that allows enabling or disabling features based on a context.
 *
 * @template T - The type of the context.
 */
export interface FeatureToggler {
  /**
   * An observable that emits when feature flags are re-evaluated,
   * typically after context changes
   */
  featureStateChanged$: Observable<void>;

  /**
   * Checks if a feature is enabled for the given user and context.
   *
   * @param feature - The name of the feature.
   * @returns A boolean indicating whether the feature is enabled.
   */
  isFeatureEnabled(feature: string): boolean;

  /**
   * Identifies the user context for feature flag evaluation.
   *
   * @param context - The evaluation context containing user information (can be a string email or a full context object)
   */
  identify(context: EvaluationContext | string): void;
}
